module.exports = __webpack_public_path__ + "static/prwc-50ef43c64f2571b7b0c2a13043d640b5.png";